import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAll,
  clearResetBot,
  onAddEvaluation,
  onGetAdditionalDocuments,
  onGetEvaluations,
  setCertificateDetails,
  setErrorMessageNotapUser,
  setEvalDetails,
  setLoadingNotapUser,
  setPreviousCertificateId,
  showCommentRichTextFormFunc,
  showDocumentCarouselFunc,
  showEvaluationDetailsFunc,
  showSendEvalFormFunc,
} from "../../../../config/redux/slice/notapUserSlice";
import { getRequest, postRequest } from "../../../../helpers/request";
import { appApi } from "../../../../utils/endpoints/appApi";
import DocumentCarousel from "../DocumentCarousel";
import NotapWrapper from "../../../layout/NotapWrapper";
import { DataTableWrapper, EvaluationInfoCard } from "../../../components";
import AddCommentDrawer from "./AddCommentDrawer";
import { evaluationDatatable } from "../../../../helpers/dataTables";
import { Link, useNavigate } from "react-router-dom";
import SendEvalModal from "./SendEvalModal";
import StatusChangeConfirmation from "./StatusChangeConfirmation";
import EvaluationDetails from "./EvaluationDetails";
import AddEvaluationModal from "./AddEvaluationModal";
import { setCertificateDetailsGeneral } from "../../../../config/redux/slice/appSlice";

export default function EvaluationHistory() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [notapStaff, setNotapStaff] = useState({});
  const { token, userData } = useSelector((state) => state.authData);
  const { currencies, isRefreshed } = useSelector((state) => state.app);
  const {
    notapUserLoading,
    notapUserErrorMsg,
    notapUserSuccessMsg,
    certificateManagement: { certificateDetails, showStatusChangeConfirmation },
    evaluationManagement: {
      showCommentRichTextForm,
      showEvaluationDetails,
      showDocumentCarousel,
      showSendEvalForm,
      newData,
      hasBeenSent,
      evaluationDetails,
      evaluationsData,
    },
  } = useSelector((state) => state.notapUser);
  useEffect(() => {
    dispatch(clearAll({}));
    let shouldShow = certificateDetails?.NOTAP_STAFF_EMAIL == userData?.email;
    if (isRefreshed == "") {
      getSingleCertificate();
    }
    evaluationDatatable(
      evaluationsData,
      setDetails,
      shouldShow,
      userData?.email,
      certificateDetails?.CERTIFICATE_STATUS,
    );
    getEvaluationHistory();
    getAdditionalDocs();
  }, []);

  useEffect(() => {
    getNotapStaff();
    getAdditionalDocs();
  }, []);

  console.log("on notap");
  const [latestEvalSender, setLatestEvalSender] = useState("");

  const getSingleCertificate = async () => {
    const res = await getRequest(
      token,
      `${appApi.getSingleCertificate(certificateDetails.ID)}`,
      {},
      dispatch,
      "",
      "",
      "",
    );
    if (res != undefined && res.status < 400) {
      dispatch(
        setCertificateDetailsGeneral({ details: res.data.data, modal: false }),
      );
      dispatch(setCertificateDetails({ details: res.data.data, modal: false }));
    }
  };

  const getEvaluationHistory = async () => {
    dispatch(clearAll({}));
    const data = {
      certificate_id: certificateDetails?.ID,
    };
    const res = await postRequest(
      token,
      `${appApi.getEvaluationHistory}`,
      data,
      dispatch,
      setLoadingNotapUser,
      onGetEvaluations,
      setErrorMessageNotapUser,
    );
    if (res != undefined && res.status < 400) {
      let evalList = res.data.data;
      if (evalList.length > 0) {
        evalList = evalList.filter((evalItem) => evalItem.IS_LATEST == 1);
        setLatestEvalSender(evalList[0]?.SENDER_ID);
      }
    }
  };

  const getNotapStaff = async () => {
    dispatch(clearAll({}));

    const res = await getRequest(
      token,
      `${appApi.getStaff}`,
      {},
      dispatch,
      setLoadingNotapUser,
      "",
      setErrorMessageNotapUser,
    );
    if (res != undefined && res.status < 400) {
      let dataList = res.data.data.filter(
        (resItem) => resItem.EMAIL == certificateDetails?.NOTAP_STAFF_EMAIL,
      );
      if (dataList.length > 0) {
        setNotapStaff(dataList[0]);
      }
    }
  };

  const setDetails = (data, type) => {
    // dispatch(setCertificateDetails({details: data, modal: true}))
    // dispatch(setCertificateDetailsGeneral({details: data, modal: true}))
    dispatch(setEvalDetails({ details: data }));
    if (type == "edit-eval") {
      dispatch(
        showCommentRichTextFormFunc({
          modal: true,
          status: "draft",
          evalId: data.ID,
        }),
      );
    } else if (type == "send-eval") {
      dispatch(
        showSendEvalFormFunc({ modal: true, status: "sent", evalId: data.ID }),
      );
    } else if (type == "eval-details") {
      dispatch(showEvaluationDetailsFunc({ modal: true }));
      // dispatch(showSendEvalFormFunc({modal: true, status: 'sent', evalId: data.ID }))
    }
    console.log("SET DETAILS CLICKED:", { data, type });
  };

  const getAdditionalDocs = async () => {
    const res = await getRequest(
      token,
      `${appApi.getAdditionalDocuments(certificateDetails.ID)}`,
      {},
      dispatch,
      "",
      onGetAdditionalDocuments,
      "",
    );
  };

  useEffect(() => {
    if (newData) {
      let shouldShow = certificateDetails?.NOTAP_STAFF_EMAIL == userData?.email;
      evaluationDatatable(
        evaluationsData,
        setDetails,
        shouldShow,
        userData?.email,
        certificateDetails?.CERTIFICATE_STATUS,
      );
      dispatch(clearResetBot());
    }
    if (
      notapUserSuccessMsg === "Evaluation Added Successfully" ||
      notapUserSuccessMsg === "Evaluation Sent Successfully"
    ) {
      getEvaluationHistory();
    }
  }, [newData, notapUserSuccessMsg]);
  return (
    <NotapWrapper pageTitle={"Evaluation History"}>
      <div>
        {showSendEvalForm && <SendEvalModal />}
        {showCommentRichTextForm && <AddEvaluationModal />}
        {showStatusChangeConfirmation && (
          <StatusChangeConfirmation certificateID={certificateDetails?.ID} />
        )}
        {showDocumentCarousel && (
          <DocumentCarousel certificateDetails={certificateDetails} />
        )}
        {showEvaluationDetails && <EvaluationDetails />}
        {/* <CardSummary /> */}
        {certificateDetails?.NOTAP_STAFF_EMAIL &&
          certificateDetails?.NOTAP_STAFF_EMAIL != "" &&
          certificateDetails?.NOTAP_STAFF_EMAIL != "N/A" && (
            <EvaluationInfoCard nextStaff={notapStaff} />
          )}
        <DataTableWrapper
          tableID="evaluationTable"
          tableName="Evaluation"
          tableButtons={<ActionButtons latestEvalSender={latestEvalSender} />}
        >
          <thead>
            <tr>
              <th width={"20px"} data-orderable="false"></th>
              <th width={"16%"}>Role</th>
              <th width={"24%"}>User</th>
              <th>Comment</th>
              <th width={"16%"}>Created At</th>
              <th width={"9%"} data-orderable="false">
                Action
              </th>
            </tr>
          </thead>
          <tbody></tbody>
        </DataTableWrapper>
      </div>
    </NotapWrapper>
  );
}

function ActionButtons({ latestEvalSender }) {
  const dispatch = useDispatch();
  const [previousRequests, setPreviousRequests] = useState([]);
  const { userData } = useSelector((state) => state.authData);
  const {
    certificateManagement: { certificateDetails },
    evaluationManagement: {
      showCommentRichTextForm,
      hasAddedEval,
      newData,
      evaluationsData,
    },
  } = useSelector((state) => state.notapUser);

  console.log({
    staffEmail: certificateDetails?.NOTAP_STAFF_EMAIL,
    userEmail: userData?.email,
    latestEvalSender,
    status: certificateDetails?.CERTIFICATE_STATUS,
  });

  useEffect(() => {
    if (certificateDetails?.PREV_IDS) {
      let prev_ids = certificateDetails?.PREV_IDS?.split(",");
      let dataList = Array.from(prev_ids, (option, index) => {
        return {
          id: index,
          name: `Request (${index + 1})`,
          certificate_id: option,
        };
      });
      setPreviousRequests(dataList);
    }
  }, []);
  return (
    <div
      style={{ columnGap: "0.5rem", rowGap: "0.6rem" }}
      className="d-flex flex-wrap"
    >
      {certificateDetails?.NOTAP_STAFF_EMAIL === userData?.email &&
        certificateDetails?.NOTAP_STAFF_EMAIL !== latestEvalSender &&
        certificateDetails?.CERTIFICATE_STATUS?.toLowerCase() === "pending" && (
          <button
            onClick={() => {
              dispatch(setEvalDetails({ details: "" }));
              dispatch(
                showCommentRichTextFormFunc({
                  modal: true,
                  status: "draft",
                  evalId: null,
                }),
              );
            }}
            className="btn btn-sm btn-outline-primary"
          >
            <i
              style={{ fontSize: "1rem" }}
              className="mdi mdi-plus-circle mr-1"
            ></i>
            Add Evaluation
          </button>
        )}
      {/* <button className='btn btn-sm btn-outline-primary'>
        <i style={{fontSize: '1rem'}} className="mdi mdi-plus-circle mr-1"></i>
        Add Letter
      </button> */}
      <button
        onClick={() => {
          dispatch(showDocumentCarouselFunc({ modal: true }));
        }}
        className="btn btn-sm btn-outline-primary"
      >
        <i
          style={{ fontSize: "1rem" }}
          className="mdi mdi-folder-open mr-1"
        ></i>
        View Documents
      </button>
      {certificateDetails?.PREV_IDS && (
        <div className="dropdown">
          <button
            className="btn btn-primary dropdown-toggle text-white"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            data-display="static"
          >
            Previous Evaluation
          </button>
          <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <>
              {previousRequests.map((singleRequest) => {
                return (
                  <Link
                    key={singleRequest.id}
                    onClick={() => {
                      dispatch(setPreviousCertificateId(singleRequest));
                    }}
                    to={`/notap/certificates/${encodeURIComponent(
                      certificateDetails?.CERTIFICATE_NUMBER,
                    )}/previous-evaluation-history`}
                    className="dropdown-item"
                    href="#"
                  >
                    {singleRequest.name}
                  </Link>
                );
              })}
            </>
          </div>
        </div>
      )}
    </div>
  );
}
